import { IAction, ActionType } from "../actions/actiontype";
import * as _ from 'lodash';
import * as Classes from "../../../classes/index"
import { updateArray } from "../../../helpers/index";
import { IWaiver, defaultWaiver, IFormAnswer, Routes } from "../../../classes/index";

export interface StepCountModel {
    stepNumber: number
}

export const defaultStepCountModel: StepCountModel = {
    stepNumber: Routes.indexOf(window.location.hash.substr(1))
};

export default function stepFourReducer(state: StepCountModel = defaultStepCountModel, action: IAction) {
    switch (action.type) {
        case ActionType.TO_STEP: {
            return _.assign({}, state, { stepNumber: action.value });
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/reducers/step-count-reducer.ts